"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var mappings = {
  400: "Bad Request! We're sorry, an error occurred when processing your request. Please refresh and try again.",
  401: "Unauthorized! We're sorry it appears you're not logged in. Please log in.",
  402: 'User Agreement Not Accepted - Please accept the user agreement before proceeding',
  403: "Forbidden! We're sorry it appears you do not have access to view this content.",
  408: "Request Timeout! We're sorry it appears the content for this page is taking longer then normal to load. Please try again soon.",
  429: "Locked! We're sorry it looks like your account is locked. Please try again later or reset your password",
  500: "Internal Server Error! We're sorry it appears our services are down. Please try again soon.",
  502: "Bad Gateway! We're sorry it looks like something went wrong. Please try again soon.",
  503: 'Service Unavailable! The server is currently unable to handle your request at this time. Please try again soon.',
  504: 'Gateway Timeout! The server timed out when processing your request. Please refresh the page and try again.'
};
var defaultMsg = "We're sorry an error occurred. Our site may be temporarily down. Please try again.";

var _default = function _default(response) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (options.useResponseMessage && typeof response === 'string') {
    return response;
  }

  if (!response || (0, _typeof2.default)(response) !== 'object') {
    return undefined;
  }

  if (options.useResponseMessage) {
    return (response.body || {}).message || response.body;
  }

  return (options.mappings || [])[response.status] || mappings[response.status] || options.defaultMessage || defaultMsg;
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/getErrorMessage.js
// module id = 264
// module chunks = 25